import React, { useState, Fragment } from 'react';
import { X, ChevronRight, ChevronLeft, Check } from 'lucide-react';
export function RequestCallModal({
  onClose
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const [question, setQuestion] = useState('');
  const [aiAnswer, setAiAnswer] = useState('');
  const [formData, setFormData] = useState({
    province: '',
    practiceArea: '',
    name: '',
    email: '',
    phone: ''
  });
  const handleNextStep = () => {
    if (currentStep === 1 && question) {
      // Simulate AI generating an answer
      setAiAnswer("Based on the information provided, it appears you're dealing with an employment contract issue. In most provinces, employers must provide reasonable notice or payment in lieu of notice when terminating an employee without cause. The specific requirements vary by province and depend on factors like length of service and position.");
      setCurrentStep(2);
    } else if (currentStep === 2) {
      setCurrentStep(3);
    } else if (currentStep === 3) {
      // Auto-detect province and practice area based on question
      setFormData({
        ...formData,
        province: 'Ontario',
        practiceArea: 'Employment Law'
      });
      setCurrentStep(4);
    } else if (currentStep === 4) {
      // Submit form and close modal in a real app
      onClose();
    }
  };
  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-692">
      <div className="bg-white rounded-lg w-full max-w-2xl mx-4" data-id="element-693">
        <div className="flex justify-between items-center p-4 border-b" data-id="element-694">
          <h2 className="text-lg font-semibold" data-id="element-695">
            Request a Call with a Lawyer
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-696">
            <X className="w-5 h-5" data-id="element-697" />
          </button>
        </div>
        <div className="p-6" data-id="element-698">
          <div className="flex items-center mb-6" data-id="element-699">
            {[1, 2, 3, 4].map(step => <Fragment key={step} data-id="element-700">
                <div className={`flex items-center justify-center w-8 h-8 rounded-full ${currentStep >= step ? 'bg-teal-500 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-701">
                  {currentStep > step ? <Check className="w-4 h-4" data-id="element-702" /> : step}
                </div>
                {step < 4 && <div className={`flex-1 h-1 mx-2 ${currentStep > step ? 'bg-teal-500' : 'bg-gray-200'}`} data-id="element-703"></div>}
              </Fragment>)}
          </div>
          {currentStep === 1 && <div data-id="element-704">
              <h3 className="text-lg font-medium mb-2" data-id="element-705">
                What's your legal question?
              </h3>
              <p className="text-gray-500 mb-4" data-id="element-706">
                Describe your situation so we can connect you with the right
                lawyer.
              </p>
              <textarea value={question} onChange={e => setQuestion(e.target.value)} className="w-full border border-gray-300 rounded-md p-3 h-32 focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="e.g., I was let go from my job without notice. What are my rights?" data-id="element-707"></textarea>
            </div>}
          {currentStep === 2 && <div data-id="element-708">
              <h3 className="text-lg font-medium mb-2" data-id="element-709">AI-Generated Answer</h3>
              <p className="text-gray-500 mb-4" data-id="element-710">
                Here's what our AI has found based on your question:
              </p>
              <div className="bg-gray-50 border border-gray-200 rounded-md p-4 mb-4" data-id="element-711">
                <p data-id="element-712">{aiAnswer}</p>
              </div>
              <p className="text-sm text-gray-500" data-id="element-713">
                This is general information and may not apply to your specific
                situation.
              </p>
            </div>}
          {currentStep === 3 && <div data-id="element-714">
              <h3 className="text-lg font-medium mb-2" data-id="element-715">
                Do you still want to talk to a lawyer?
              </h3>
              <p className="text-gray-500 mb-4" data-id="element-716">
                A lawyer can provide personalized advice for your specific
                situation.
              </p>
              <div className="flex space-x-4" data-id="element-717">
                <button onClick={handleNextStep} className="flex-1 bg-teal-500 hover:bg-teal-600 text-white py-2 px-4 rounded-md transition-colors" data-id="element-718">
                  Yes, connect me with a lawyer
                </button>
                <button onClick={onClose} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-md transition-colors" data-id="element-719">
                  No, the AI answer helped
                </button>
              </div>
            </div>}
          {currentStep === 4 && <div data-id="element-720">
              <h3 className="text-lg font-medium mb-2" data-id="element-721">
                Complete your information
              </h3>
              <p className="text-gray-500 mb-4" data-id="element-722">
                We've detected the following details from your question:
              </p>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-723">
                <div data-id="element-724">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-725">
                    Province
                  </label>
                  <select value={formData.province} onChange={e => setFormData({
                ...formData,
                province: e.target.value
              })} className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-726">
                    <option value="Ontario" data-id="element-727">Ontario</option>
                    <option value="British Columbia" data-id="element-728">British Columbia</option>
                    <option value="Alberta" data-id="element-729">Alberta</option>
                    <option value="Quebec" data-id="element-730">Quebec</option>
                    <option value="Other" data-id="element-731">Other</option>
                  </select>
                </div>
                <div data-id="element-732">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-733">
                    Practice Area
                  </label>
                  <select value={formData.practiceArea} onChange={e => setFormData({
                ...formData,
                practiceArea: e.target.value
              })} className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-734">
                    <option value="Employment Law" data-id="element-735">Employment Law</option>
                    <option value="Family Law" data-id="element-736">Family Law</option>
                    <option value="Real Estate" data-id="element-737">Real Estate</option>
                    <option value="Business Law" data-id="element-738">Business Law</option>
                    <option value="Other" data-id="element-739">Other</option>
                  </select>
                </div>
              </div>
              <div className="space-y-4" data-id="element-740">
                <div data-id="element-741">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-742">
                    Full Name
                  </label>
                  <input type="text" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="John Doe" data-id="element-743" />
                </div>
                <div data-id="element-744">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-745">
                    Email
                  </label>
                  <input type="email" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="john@example.com" data-id="element-746" />
                </div>
                <div data-id="element-747">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-748">
                    Phone Number
                  </label>
                  <input type="tel" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="(123) 456-7890" data-id="element-749" />
                </div>
              </div>
            </div>}
        </div>
        <div className="flex justify-between p-4 border-t" data-id="element-750">
          {currentStep > 1 ? <button onClick={handlePrevStep} className="flex items-center text-gray-600 hover:text-gray-800" data-id="element-751">
              <ChevronLeft className="w-4 h-4 mr-1" data-id="element-752" />
              Back
            </button> : <div data-id="element-753"></div>}
          {currentStep < 4 ? <button onClick={handleNextStep} disabled={currentStep === 1 && !question} className={`flex items-center ${currentStep === 1 && !question ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-teal-500 hover:bg-teal-600 text-white'} py-2 px-4 rounded-md transition-colors`} data-id="element-754">
              {currentStep === 3 ? 'Complete Form' : 'Next'}
              <ChevronRight className="w-4 h-4 ml-1" data-id="element-755" />
            </button> : <button onClick={handleNextStep} className="bg-teal-500 hover:bg-teal-600 text-white py-2 px-4 rounded-md transition-colors" data-id="element-756">
              Schedule Call
            </button>}
        </div>
      </div>
    </div>;
}